import React, { useState } from "react";

//STYLES
import * as ControllerStyles from "../styles/controller";

function GrowHeight(props) {
    const [animHeight, setAnimHeight] = useState(40);

    function handleOnEnter() {
        setAnimHeight(90);
    }

    function handleOnLeave() {
        setAnimHeight(40);
    }

    return (
        <div
            style={{ ...ControllerStyles.menuItem_HeightAnimation, ...props.style, height: `${animHeight}px` }}
            onMouseEnter={handleOnEnter}
            onMouseLeave={handleOnLeave}
        ></div>
    );
}

export default GrowHeight;
